import type ConnectorAttachmentBehaviors from '../objects/ConnectorAttachmentBehaviors';

// Gets all objects connected to this object
export const getConnectorAttachmentObjects = (
  object: fabric.Object & ConnectorAttachmentBehaviors
): (fabric.Object & ConnectorAttachmentBehaviors)[] => {
  const connectedObjects: (fabric.Object & ConnectorAttachmentBehaviors)[] = [];
  for (const connectorAttachment of object.connectorAttachments) {
    const connector = connectorAttachment.connector;
    const attachments = connector.attachments
      .filter(att => att?.object.id !== object.id)
      .map(att => att?.object)
      .filter(Boolean) as (fabric.Object & ConnectorAttachmentBehaviors)[];

    // Technically this will always be at most one, but it could be an empty array as well
    connectedObjects.push(...attachments);
  }

  return connectedObjects;
};
